import { FunctionalComponent, h } from "@stencil/core";
import { SortDirection } from "../table-types";

interface TableHeaderProps {
    group?: boolean;
    sortable?: boolean;
    label?: string;
    sortField?: string;
    testId?: string;
    initialSortDirection: SortDirection;
}

const tableClass = "uic-table";
export const TableHeader: FunctionalComponent<TableHeaderProps> = (
    { group = false, sortable = false, label = "", sortField = "", testId = null, initialSortDirection = "" },
    children
) => {
    const testIdValue = testId == null ? null : `${tableClass}__th-${testId}`;
    return (
        <th
            class={{
                [`${tableClass}__th`]: true,
                [`${tableClass}__th--group`]: group
            }}
            data-testid={testIdValue}
            scope='row'
        >
            {sortable && label !== "" && (
                <uic-table-head-sort sortField={sortField !== "" ? sortField : null} sortedDirection={initialSortDirection}>
                    {label}
                </uic-table-head-sort>
            )}
            {!sortable && label !== "" && label}
            {children}
        </th>
    );
};
